import { Injectable } from '@angular/core';
import { Http, BaseRequestOptions, RequestOptions } from '@angular/http';

@Injectable()
export class PafRequestOptions extends BaseRequestOptions{
    constructor() {
      super();
      this.withCredentials = true;
      this.headers.set('Content-Type', 'application/json');
    }

}

export const pafRequestOptionsProvider = { provide: RequestOptions, useClass: PafRequestOptions };



// WEBPACK FOOTER //
// ./src/app/_providers/PafRequestOptions.provider.ts